import Vue from 'vue'
import VueI18n from 'vue-i18n'
import customValidationMessages from '@/utils/validators/messages'
import { LOCAL_STORE_NAMES } from '@/constants/settings.js'

Vue.use(VueI18n)

// initialization current localization
let locale = localStorage.getItem(LOCAL_STORE_NAMES.LOCALE)
if (!locale) {
  localStorage.setItem(LOCAL_STORE_NAMES.LOCALE, process.env.VUE_APP_I18N_LOCALE || 'en')
  locale = localStorage.getItem(LOCAL_STORE_NAMES.LOCALE)
}
const validationMessages = require(`vee-validate/dist/locale/${locale}.json`)
// for all app components
const messages = require(`./i18n/${locale}.json`)
// for veeValidate
const validations = {
  ...validationMessages.messages,
  ...customValidationMessages[locale].messages
}
const localeMessages = locale === 'ru'
  ? {
    ru: {
      ...messages,
      validation: validations
    }
  }
  : {
    en: {
      ...messages,
      validation: validations
    }
  }

export default new VueI18n({
  locale: locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: localeMessages,
  silentTranslationWarn: true
})
